/**
 * SIW.Reserva - Sistema Integrado de Reservas (VERSIÓN EXTENDIDA)
 * Módulo unificado con patrón IIFE + Namespace + Soporte para Flatpickr
 * @version 2.2.0
 * @author Morffe
 */
(function($) {
    'use strict';

    // =====================================================
    // CONFIGURACIÓN GLOBAL
    // =====================================================
    const config = {
        debug: sessionStorage.getItem('mydebug') ?? false,
        timeouts: {
            reservation: 900, // 15 minutos
            ajax: 30000,
            updateInterval: 1000
        },
        fallbackPrices: {
            private: -1.00,
            shared: -2.00
        },
        validation: {
            email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            phone: /^[+]?[\d\s]{8,15}$/,
            time: /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/
        },
        // Configuración de flatpickr
        flatpickr: {
            locale: window.bbb.config.lang === 'eng' ? 'en' : 'es',
            dateFormat: 'd/m/Y',
            minDate: 'today'
        }
    };

    // =====================================================
    // MÓDULO PRINCIPAL
    // =====================================================
    const SIWReserva = {

        _initialized: false,
        _eventsRegistered: false,
        _sessionId: null,
        getSessionId: function() {
            if (!this._sessionId) {
                this._sessionId = this.storage.get('sessionId');
                if (!this._sessionId) {
                    this._sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
                    this.storage.set('sessionId', this._sessionId);
                }
            }
            return this._sessionId;
        },
        setSessionId: function(id) {
            this._sessionId = id;
            this.storage.set('sessionId', id);
        },

        // [monitor] Helper para enviar eventos de monitorización al servidor
        // Fire and forget — no bloquea el UI
        _monitorLog: function(node, processKey, message, level, context) {
            try {
                fetch(window.bbb.routes['monitor.log.js'], {
                    method: 'POST',
                    keepalive: true,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.content ?? ''
                    },
                    body: JSON.stringify({
                        node: node,
                        process_key: processKey,
                        message: message,
                        level: level || 'info',
                        context: context || {}
                    })
                });
            } catch(e) {
                // [monitor] Silencioso — nunca rompe el flujo principal
            }
        },

        // =================================================
        // UTILS - UTILIDADES GENÉRICAS (EXTENDIDO)
        // =================================================
        utils: {
            /**
             * Formatea un valor numérico como moneda
             */
            formatCurrency: function(value) {
                const numericValue = parseFloat(value);
                return isNaN(numericValue) ? '0,00 EUR' : numericValue.toFixed(2).replace('.', ',') + ' EUR';
            },

            /**
             * Parsea una cadena de precio a número
             */
            parsePrice: function(priceString) {
                if (!priceString) return 0;
                return parseFloat((priceString + '').replace(' EUR', '').replace(',', '.'));
            },

            /**
             * Hace scroll suave a un elemento
             */
            scrollTo: function(selector, offset = 100, duration = 500) {
                if (window.self !== window.top) {
                    var el = $(selector);
                    if (el.length) {
                        var elTop = el.offset().top; // posición dentro del iframe
                        window.parent.postMessage({
                            tipo: 'scrollTo',
                            elTop: elTop,
                            offset: offset
                        }, '*');
                    }
                } else {
                    $('html, body').animate({
                        scrollTop: $(selector).offset().top - offset
                    }, duration);
                }
            },

            /**
             * Muestra/oculta loader global
             */
            loader: function(status) {
                const numeroAleatorio = Math.floor(Math.random() * 2) + 1;

                if (status === 'loading') {
                    if ($('#cocktail-overlay').length === 0) {
                        $('body').append(`
                            <div id="cocktail-overlay">
                                <img src="/img/loader-${numeroAleatorio}.gif"
                                     alt="Loading..."
                                     class="cocktail-loading-gif">
                            </div>
                        `);
                        setTimeout(() => $('#cocktail-overlay').addClass('cocktail-show'), 10);
                    } else {
                        $('#cocktail-overlay').addClass('cocktail-show');
                    }
                } else {
                    $('#cocktail-overlay').removeClass('cocktail-show');
                    setTimeout(() => $('#cocktail-overlay').remove(), 400);
                }
            },

            /**
             * Alterna estado de loading en botones
             */
            toggleLoading: function(selector, isLoading, originalText) {
                if (isLoading) {
                    if (!$(selector).prop('disabled')) {
                        $(selector).data('orig-html', $(selector).html());
                    }
                    $(selector).html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Procesando...');
                    $(selector).prop('disabled', true);
                } else {
                    $(selector).html(originalText || $(selector).data('orig-html') || 'Continuar');
                    $(selector).prop('disabled', false);
                }
            },

            /**
             * Obtiene parámetro de URL
             */
            getUrlParameter: function(name) {
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
                const results = regex.exec(location.search);
                return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
            },

            /**
             * Sistema de logging mejorado
             */
            log: function(message, type = 'info', context = '') {
                if (!config.debug) return;
                const label = context ? `[${context}]` : '';
                window.consola(label, message, type);
            },

            /**
             * Manejo centralizado de errores
             */
            handleError: function(error, context) {
                this.log(error, 'error', context);
                if (config.debug) {
                    console.trace();
                }
            },

            /**
             * Configurar Flatpickr con fechas deshabilitadas
             */
            configurarFlatpickr: function(selector, fechasDeshabilitadas = []) {
                try {
                    this.log(`Configurando flatpickr para ${selector}`, 'info', 'utils.configurarFlatpickr');

                    // Verificar si flatpickr está disponible
                    if (typeof flatpickr !== 'function') {
                        this.log('Flatpickr no está disponible. Asegúrate de cargarlo antes que bbb-core.js', 'warn', 'utils.configurarFlatpickr');
                        return false;
                    }

                    const fechasSolo = fechasDeshabilitadas.map(item => item.fecha);

                    // Configuración de flatpickr
                    const flatpickrConfig = {
                        disable: fechasSolo,
                        locale: (window.bbb?.config?.lang === 'eng') ? 'en' : 'es',
                        minDate: config.flatpickr.minDate,
                        defaultDate: new Date(new Date().setDate(new Date().getDate() + 1)).toLocaleDateString('es-ES'),
                        dateFormat: config.flatpickr.dateFormat,
                        onDayCreate: function(dObj, dStr, fp, dayElem) {
                            fechasDeshabilitadas.forEach(item => {
                                const [day, month, year] = item.fecha.split('/');
                                const formattedDate = new Date(year, month - 1, day).toISOString().slice(0, 10);

                                if (dayElem.dateObj && formattedDate === dayElem.dateObj.toISOString().slice(0, 10)) {
                                    dayElem.setAttribute('title', item.tooltip || 'No disponible');
                                    dayElem.classList.add('flatpickr-disabled');
                                }
                            });
                        },
                        onChange: function(selectedDates, dateStr, instance) {
                            // Trigger change event para compatibilidad con el sistema existente
                            $(selector).trigger('change');
                        }
                    };

                    // Inicializar flatpickr
                    const fpInstance = flatpickr(selector, flatpickrConfig);

                    this.log('Flatpickr configurado correctamente', 'info', 'utils.configurarFlatpickr');
                    return fpInstance;

                } catch (e) {
                    this.handleError(e, 'utils.configurarFlatpickr');
                    return false;
                }
            },

            /**
             * Verificar dependencias externas
             */
            verificarDependencias: function() {
                const dependencias = {
                    jquery: typeof $ !== 'undefined',
                    flatpickr: typeof flatpickr !== 'undefined',
                };

                this.log('Estado de dependencias:', 'info', 'utils.verificarDependencias');
                Object.keys(dependencias).forEach(dep => {
                    const estado = dependencias[dep] ? '✅' : '❌';
                    this.log(`${estado} ${dep}: ${dependencias[dep]}`, 'info', 'utils.verificarDependencias');
                });

                return dependencias;
            },

            /**
             * Obtener configuración global desde window.SIW_CONFIG
             */
            obtenerConfigGlobal: function() {
                if (window.SIW_CONFIG) {
                    // Merge configuración global con configuración local
                    Object.assign(config, window.SIW_CONFIG);
                    this.log('Configuración global cargada', 'info', 'utils.obtenerConfigGlobal');
                } else {
                    this.log('No se encontró configuración global (window.SIW_CONFIG)', 'warn', 'utils.obtenerConfigGlobal');
                }
            },

            /**
             * Location Inteligente
             */
            redirect: function(url, useOriginalForBooking = false) {
                if (!url) {
                    url = SIWReserva.storage.get('originalBookingURL') || window.location.href;
                }
                if (useOriginalForBooking && url.includes('/booking')) {
                    const originalURL = SIWReserva.storage.get('originalBookingURL');
                    if (originalURL) {
                        window.location.href = originalURL;
                        return;
                    }
                }
                window.location.href = url;
            },

            renderGallery: function(images) {
                const gallery = $('#image-gallery');
                gallery.empty();
                gallery.removeClass('gallery-1 gallery-2 gallery-3 gallery-4');
                if (!images || images.length === 0) return;
                const count = Math.min(images.length, 4);
                gallery.addClass('gallery-' + count);
                for (let i = 0; i < count; i++) {
                    const roundedClass = i === 0 ? 'rounded-start' : (i === count - 1 ? (count <= 2 ? 'rounded-end' : 'rounded-bottom-right') : (i === count - 2 && count > 2 ? 'rounded-top-right' : ''));
                    gallery.append(`<div class="custom2-box ${roundedClass}"><img src="${images[i]}" alt=""></div>`);
                }
            },

            /**
             * Muestra formulario de contacto cuando no hay datos de ciudad
             */
            showContactForm: function(cityParam, images, response_titulo, response_descripcion) {

                $('#city-info').hide();
                $('#acerca-titulo').hide();
                $('#main-booking-card').hide();
                $('#col-precio').hide();
                $('#col-main').removeClass('col-8').addClass('col-12');

                SIWReserva.utils.renderGallery(images);

                const cityName = cityParam ? cityParam.toUpperCase() : 'esta ciudad';
                const titulo = response_titulo || cityName;
                const descripcion = response_descripcion || '';

                const contactFormHTML = `
                    <div class="mt-3 mb-4">
                        <h3 id="dynamic-title">${titulo}</h3>
                        <p class="text-muted">${descripcion}</p>
                    </div>
                    <div class="card border-0 shadow-sm">
                        <div class="card-body p-4">
                            <div class="text-center mb-4">
                                <i class="mdi mdi-map-marker-off text-muted" style="font-size: 3rem;"></i>
                                <h4 class="mt-3 mb-2">${cityName}</h4>
                                <p class="text-muted">Aún no tenemos disponibilidad en esta ubicación, pero queremos saber de ti.</p>
                            </div>
                            <form id="city-contact-form">
                                <input type="hidden" name="ciudad_solicitada" value="${cityParam || ''}">
                                <input type="text" name="company" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;width:1px;height:1px">
                                <input type="hidden" id="cf-turnstile-city-token" name="cf-turnstile-response" value="">
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label for="contact_nombre" class="form-label">Nombre *</label>
                                        <input type="text" class="form-control" id="contact_nombre" name="nombre" required>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label for="contact_email" class="form-label">Email *</label>
                                        <input type="email" class="form-control" id="contact_email" name="email" required>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label for="contact_mensaje" class="form-label">Mensaje</label>
                                    <textarea class="form-control" id="contact_mensaje" name="mensaje" rows="4"></textarea>
                                </div>
                                <div class="mb-3">
                                    <div class="cf-turnstile" data-sitekey="${window.TURNSTILE_SITE_KEY}" data-callback="onCityFormTurnstileSuccess" data-appearance="always"></div>
                                </div>
                                <div class="text-center">
                                    <button type="submit" id="city-contact-submit" class="btn btn-secondary" disabled>
                                        <i class="mdi mdi-send me-2"></i>Enviar Mensaje
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                `;

                $('#col-main').append(contactFormHTML);

                // Render Turnstile manually since it's dynamically injected
                if (window.turnstile) {
                    window.turnstile.render('.cf-turnstile', {
                        sitekey: window.TURNSTILE_SITE_KEY,
                        callback: function(token) {
                            document.getElementById('city-contact-submit').disabled = false;
                            document.getElementById('cf-turnstile-city-token').value = token;
                        }
                    });
                }

                $('#loading-galeria').hide();

                // Configurar evento del formulario
                this.setupContactFormEvents();
            },

            /**
             * Configura eventos del formulario de contacto
             */
            setupContactFormEvents: function() {
                $(document).off('submit', '#city-contact-form').on('submit', '#city-contact-form', function(e) {
                    e.preventDefault();

                    const formData = {
                        ciudad_solicitada: $('#city-contact-form input[name="ciudad_solicitada"]').val(),
                        nombre: $('#contact_nombre').val().trim(),
                        email: $('#contact_email').val().trim(),
                        mensaje: $('#contact_mensaje').val().trim()
                    };
                    formData['cf-turnstile-response'] = $('#cf-turnstile-city-token').val();

                    // Validación básica
                    if (!formData.nombre || !formData.email) {
                        alert('Por favor, completa todos los campos obligatorios.');
                        return;
                    }

                    if (!config.validation.email.test(formData.email)) {
                        alert('Por favor, introduce un email válido.');
                        return;
                    }

                    if (!formData['cf-turnstile-response']) {
                        alert('Por favor, completa la verificación de seguridad.');
                        return;
                    }

                    // Enviar formulario
                    SIWReserva.utils.toggleLoading('#city-contact-form button[type="submit"]', true);

                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    });

                    $.ajax({
                        url: API_ROUTES.submitCityContact,
                        method: 'POST',
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        data: formData,
                        success: function(response) {
                            if (response.success) {
                                $('#city-contact-form').html(`
                                    <div class="text-center">
                                        <i class="mdi mdi-check-circle text-success" style="font-size: 3rem;"></i>
                                        <h5 class="mt-3 text-success">¡Solicitud enviada!</h5>
                                        <p class="text-muted">Te contactaremos pronto para informarte sobre disponibilidad en ${formData.ciudad_solicitada}.</p>
                                    </div>
                                `);
                            } else {
                                alert('Error al enviar la solicitud. Por favor, inténtalo de nuevo.');
                            }
                        },
                        error: function(xhr) {
                            alert('Error al enviar la solicitud. Por favor, inténtalo de nuevo..');
                        },
                        complete: function() {
                            SIWReserva.utils.toggleLoading('#city-contact-form button[type="submit"]', false);
                        }
                    });
                });
            }

        },

        // =================================================
        // STORAGE - GESTIÓN DE LOCALSTORAGE
        // =================================================
        storage: {
            /**
             * Obtiene valor del localStorage con deserialización automática
             */
            get: function (key, defaultValue = null) {
                try {
                    const value = sessionStorage.getItem(key);
                    if (value === null) return defaultValue;

                    // Intentar parsear como JSON
                    return JSON.parse(value);
                } catch (e) {
                    // Si falla el parsing, devolver el valor raw
                    const rawValue = sessionStorage.getItem(key);

                    // Solo loggear en debug mode para evitar spam
                    if (SIWReserva.getConfig().debug) {
                        SIWReserva.utils.log(`Valor no-JSON en localStorage[${key}]: ${rawValue}`, 'warn', 'storage.get');
                    }

                    // Devolver valor raw o default
                    return rawValue || defaultValue;
                }
            },

            /**
             * Guarda valor en localStorage con serialización automática
             */
            set: function (key, value) {
                try {
                    if (typeof value === 'object') {
                        sessionStorage.setItem(key, JSON.stringify(value));
                    } else {
                        sessionStorage.setItem(key, value);
                    }
                } catch (e) {
                    SIWReserva.utils.handleError(e, 'storage.set');
                }
            },

            /**
             * Elimina clave del localStorage
             */
            remove: function (key) {
                sessionStorage.removeItem(key);
            },

            /**
             * Limpia localStorage preservando claves específicas
             */
            clear: function (keysToKeep = []) {
                const allKeys = Object.keys(sessionStorage);
                allKeys.forEach(key => {
                    if (!keysToKeep.includes(key) && !key.startsWith("debug") && key !== "debug") {
                        sessionStorage.removeItem(key);
                    }
                });
            },

            /**
             * Verifica si existe una clave
             */
            exists: function (key) {
                return sessionStorage.getItem(key) !== null;
            },

            syncToStorage: function () {
                // Usar el método del padre para obtener sessionId
                const sessionId = SIWReserva.getSessionId();

                // Validar sessionId antes de enviar
                if (!sessionId || !sessionId.match(/^session_\d+_[a-z0-9]{9}$/)) {
                    throw new Error('SessionId inválido');
                }

                // Obtener TODO el localStorage
                const allData = {};
                for (let i = 0; i < sessionStorage.length; i++) {
                    const key = sessionStorage.key(i);
                    allData[key] = SIWReserva.storage.get(key);
                }

                // Preparar datos con timestamp
                const sessionData = {
                    sessionId: sessionId,
                    timestamp: Date.now(),
                    data: allData
                };

                // Enviar los datos preparados (CON timestamp)
                return fetch(API_ROUTES.syncToStorage, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sessionData)
                });
            }
        },

        // =================================================
        // PRICE MANAGER - GESTIÓN DE PRECIOS
        // =================================================
        priceManager: {
            /**
             * Calcula totales de la reserva
             */
            calculateTotals: function() {
                const precios = SIWReserva.storage.get('precio', []);
                const peopleCount = parseInt(SIWReserva.storage.get('peopleCount'), 10);
                const modalidad = SIWReserva.storage.get('modalidad', '');

                let baseTotal = 0;

                // Calcular precio base
                if (Array.isArray(precios) && precios.length > 0) {
                    precios.forEach(precio => {
                        if (precio && typeof precio === 'object' && 'cantidad' in precio && 'precio_unitario' in precio) {
                            baseTotal += precio.cantidad * precio.precio_unitario;
                        }
                    });

                    // Ajuste para modalidad compartida
                    if (modalidad === 'SHARED' && precios[0] && precios[0].cantidad !== peopleCount) {
                        baseTotal *= peopleCount;
                    }
                } else {

                    const backendTotals = SIWReserva.storage.get('backendTotals', null);
                    if (backendTotals && backendTotals.baseTotal) {
                        baseTotal = backendTotals.baseTotal;
                    } else {
                        baseTotal = (modalidad === 'PRIVATE') ? config.fallbackPrices.private : config.fallbackPrices.shared * peopleCount;
                    }
                }

                // Calcular extras
                const selectedExtras = SIWReserva.storage.get('selectedExtras', []);
                let extrasTotal = 0;

                if (Array.isArray(selectedExtras)) {
                    selectedExtras.forEach(extra => {
                        if (extra && typeof extra === 'object' && 'price' in extra && 'quantity' in extra) {
                            const price = SIWReserva.utils.parsePrice(extra.price);
                            extrasTotal += price * extra.quantity;
                        }
                    });
                }

                // Aplicar descuento promocional
                const promoDiscount = parseFloat(SIWReserva.storage.get('promoDiscount', 0));
                let finalTotal = baseTotal + extrasTotal - promoDiscount;
                finalTotal = Math.max(0, finalTotal);

                const totals = {
                    baseTotal: baseTotal,
                    extrasTotal: extrasTotal,
                    promoDiscount: promoDiscount,
                    finalTotal: finalTotal
                };

                return totals;
            },

            /**
             * Actualiza la UI con los totales calculados
             */
            updateTotalsUI: function() {
                const totals = this.calculateTotals();
                const totalElement = $('.total-summary');

                if (totalElement.length === 0) return;

                totalElement.data('base-total', totals.finalTotal.toFixed(2).replace('.', ','));
                const currentTotal = SIWReserva.utils.parsePrice(totalElement.text());

                // Animación suave del precio
                if (Math.abs(currentTotal - totals.finalTotal) > 0.01) {
                    $({ total: currentTotal }).animate(
                        { total: totals.finalTotal },
                        {
                            duration: 500,
                            step: function() {
                                totalElement.text(SIWReserva.utils.formatCurrency(this.total));
                            },
                            complete: function() {
                                totalElement.text(SIWReserva.utils.formatCurrency(totals.finalTotal));
                            }
                        }
                    );
                } else {
                    totalElement.text(SIWReserva.utils.formatCurrency(totals.finalTotal));
                }
            },

            /**
             * Valida estructura de precios
             */
            validatePrices: function(prices) {
                if (!Array.isArray(prices)) return false;

                return prices.every(precio => {
                    return precio &&
                        typeof precio === 'object' &&
                        'cantidad' in precio &&
                        'precio_unitario' in precio &&
                        !isNaN(precio.cantidad) &&
                        !isNaN(precio.precio_unitario) &&
                        precio.cantidad > 0 &&
                        precio.precio_unitario > 0;
                });
            }
        },

        // =================================================
        // SUMMARY MANAGER - GESTIÓN DE RESÚMENES
        // =================================================
        summaryManager: {
            /**
             * Carga resumen básico desde el backend
             */
            loadBasicSummary: function() {

                const orderSummaryContainer = $('.card-body');

                // Preservar datos originales
                const datosReservaOriginal = {
                    selectedHour: SIWReserva.storage.get('selectedHour'),
                    peopleCount: SIWReserva.storage.get('peopleCount'),
                    modalidad: SIWReserva.storage.get('modalidad'),
                    fecha: SIWReserva.storage.get('fecha'),
                    precio: SIWReserva.storage.get('precio', []),
                    titulo: SIWReserva.storage.get('titulo'),
                    ciudad: SIWReserva.storage.get('ciudad'),
                    ciudadDescriptiva: SIWReserva.storage.get('ciudadDescriptiva')
                };

                // Validar precios
                const precios = datosReservaOriginal.precio;
                if (!SIWReserva.priceManager.validatePrices(precios)) {
                    SIWReserva.utils.handleError('Precios inválidos detectados', 'summaryManager');
                    alert("Error: Los datos de precios son inválidos. Por favor, vuelve a seleccionar una oferta.");
                    SIWReserva.utils.redirect(window.bbb.config['URL Fallback Redirection'], true);
                    return;
                }

                // Validar y limpiar extras
                const selectedExtras = SIWReserva.storage.get('selectedExtras', []);
                const extrasValidados = selectedExtras.map(extra => {
                    if (!extra.name || extra.name.trim() === '' || !extra.price || extra.price.trim() === '') {
                        const cardElement = $(`.card[data-extra-id="${extra.id}"]`);
                        if (cardElement.length) {
                            extra.name = extra.name || cardElement.find('.card-title').text().trim();
                            extra.price = extra.price || cardElement.find('.price-tag').text().trim();
                        }
                    }
                    return extra;
                });

                SIWReserva.storage.set('selectedExtras', extrasValidados);

                // Preparar datos para envío
                const reservaData = {
                    fecha: datosReservaOriginal.fecha,
                    selectedHour: datosReservaOriginal.selectedHour,
                    peopleCount: parseInt(datosReservaOriginal.peopleCount, 10),
                    modalidad: datosReservaOriginal.modalidad,
                    titulo: datosReservaOriginal.titulo,
                    ciudad: datosReservaOriginal.ciudad,
                    ciudadDescriptiva: datosReservaOriginal.ciudadDescriptiva,
                    image: SIWReserva.storage.get('image', ''),
                    precios: datosReservaOriginal.precio,
                    selectedExtras: extrasValidados,
                    promoCode: SIWReserva.storage.get('promoCode', ''),
                    promoDiscount: parseFloat(SIWReserva.storage.get('promoDiscount', 0))
                };

                // Llamada AJAX
                $.ajax({
                    url: API_ROUTES.getOrderSummaryRequest,
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        reservaData: reservaData,
                        extras: extrasValidados,
                        coupon: reservaData.promoCode,
                        promoDiscount: reservaData.promoDiscount
                    },
                    beforeSend: function() {
                        SIWReserva.utils.loader('loading');
                    },
                    success: function(response) {
                        if (!response.success) {
                            SIWReserva.utils.handleError(response.message, 'summaryManager.loadBasicSummary');
                            alert("Error al cargar el resumen del pedido: " + response.message);
                            return;
                        }

                        const data = response.data || response;

                        // Actualizar UI
                        orderSummaryContainer.find('.tour-image').attr('src', data.image);
                        orderSummaryContainer.find('.tour-title').text(data.title);


                        // Actualizar con datos del localStorage
                        const imagen = SIWReserva.storage.get('image', '');
                        const titulo = SIWReserva.storage.get('titulo', '');
                        const fecha = SIWReserva.storage.get('fecha', '');
                        const hora = SIWReserva.storage.get('selectedHour', '');
                        const horafin = SIWReserva.storage.get('hora_fin', '');
                        const ciudadDescriptiva = SIWReserva.storage.get('ciudadDescriptiva', '');

                        orderSummaryContainer.find('.tour-image').attr('src', imagen);
                        orderSummaryContainer.find('.tour-title').text(titulo);
                        orderSummaryContainer.find('.tour-availability').text(`${ciudadDescriptiva}: ${fecha}, ${hora} - ${horafin}`);

                        orderSummaryContainer.find('.tour-rating').html(
                            `<i class="bi bi-star-fill"></i> ${data.rating} (${data.reviews})`
                        );

                        // Actualizar detalles
                        const detailsList = orderSummaryContainer.find('.order-summary');
                        detailsList.empty();

                        $.each(data.details, function(index, detail) {
                            detailsList.append(
                                `<li class="mb-2"><i class="${detail.icon}"></i> ${detail.text}</li>`
                            );
                        });

                        // Actualizar total
                        if (data.total) {
                            orderSummaryContainer.find('.total-summary').text(data.total);

                            SIWReserva.storage.set('backendTotals', {
                                baseTotal: data.baseTotal || 0,
                                extrasTotal: data.extrasTotal || 0,
                                promoDiscount: data.promoDiscount || 0,
                                finalTotal: data.finalTotal || 0
                            });

                            SIWReserva.summaryManager.loadBasePrice();
                        }

                        // Restaurar datos originales
                        Object.keys(datosReservaOriginal).forEach(key => {
                            SIWReserva.storage.set(key, datosReservaOriginal[key]);
                        });

                        SIWReserva.utils.loader('hide');
                    },
                    error: function(xhr) {
                        SIWReserva.utils.handleError(xhr.responseText || xhr.statusText, 'summaryManager.loadBasicSummary');
                        alert("Error al cargar el resumen del pedido. Por favor, intenta nuevamente.");

                        // Restaurar datos originales
                        Object.keys(datosReservaOriginal).forEach(key => {
                            SIWReserva.storage.set(key, datosReservaOriginal[key]);
                        });
                    },
                    complete: function() {
                        SIWReserva.utils.loader('hide');
                    }
                });
            },

            /**
             * Carga precio base en el resumen
             */
            loadBasePrice: function() {
                const precios = SIWReserva.storage.get('precio', []);
                if (!Array.isArray(precios) || precios.length === 0) return;

                $('.extras-summary .base-price-summary').remove();

                let baseTotal = 0;
                precios.forEach(precio => {
                    const cantidad = parseInt(precio.cantidad || 1, 10);
                    const unitario = parseFloat(precio.precio_unitario || 0);
                    const descripcion = precio.descripcion || 'Precio base';
                    const subtotal = cantidad * unitario;
                    baseTotal += subtotal;

                    $('.extras-summary').append(`
                        <li class="mb-2 d-flex justify-content-between align-items-center base-price-summary">
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-center gap-2">
                                    <i class="mdi mdi-ticket text-primary"></i>
                                    <span>${descripcion}</span>
                                </div>
                                <small class="text-muted ms-4">${cantidad} × ${SIWReserva.utils.formatCurrency(unitario)}</small>
                            </div>
                            <span>${SIWReserva.utils.formatCurrency(subtotal)}</span>
                        </li>
                    `);
                });
            },

            /**
             * Actualiza un extra en el resumen
             */
            updateExtra: function(extraId, extraName, extraPrice, quantity) {

                let selectedExtras = SIWReserva.storage.get('selectedExtras', []);
                const extraIndex = selectedExtras.findIndex(extra => extra.id === extraId);

                if (extraIndex > -1) {
                    if (quantity === 0) {
                        selectedExtras.splice(extraIndex, 1);
                    } else {
                        selectedExtras[extraIndex].quantity = quantity;
                        selectedExtras[extraIndex].price = extraPrice;
                        selectedExtras[extraIndex].name = extraName;
                    }
                } else if (quantity > 0) {
                    selectedExtras.push({
                        id: extraId,
                        name: extraName,
                        price: extraPrice,
                        quantity: quantity
                    });
                }

                SIWReserva.storage.set('selectedExtras', selectedExtras);

                // Actualizar UI
                this.loadExtras();
                this.loadBasicSummary();
                SIWReserva.priceManager.updateTotalsUI();
            },

            /**
             * Carga extras en el resumen
             */
            loadExtras: function() {
                const selectedExtras = SIWReserva.storage.get('selectedExtras', []);
                const extrasList = $('.extras-summary');

                extrasList.find('li:not(.base-price-summary)').remove();

                if (selectedExtras.length === 0) return;

                selectedExtras.forEach(extra => {
                    if (!extra.name || extra.name.trim() === '' || !extra.price || extra.price.trim() === '') {
                        SIWReserva.utils.handleError('Extra con datos incompletos', 'summaryManager.loadExtras');
                        return;
                    }

                    const extraTotal = SIWReserva.utils.parsePrice(extra.price) * extra.quantity;

                    extrasList.append(`
                        <li class="mb-2 d-flex justify-content-between align-items-center" data-extra-id="${extra.id}">
                            <div class="d-flex align-items-center gap-2">
                                <i class="mdi mdi-food-fork-drink text-success"></i>
                                <span>${extra.quantity} x</span>
                                <span>${extra.name}</span>
                            </div>
                            <span>+ ${SIWReserva.utils.formatCurrency(extraTotal)}</span>
                        </li>
                    `);
                });
            },

            /**
             * Carga descuento promocional en el resumen
             */
            loadPromoDiscount: function() {
                const promoDiscount = parseFloat(SIWReserva.storage.get('promoDiscount', 0));
                const promoCode = SIWReserva.storage.get('promoCode', '');

                $('.extras-summary li.promo-discount').remove();

                if (promoDiscount > 0 && promoCode) {
                    $('.extras-summary').append(`
                        <li class="mb-2 d-flex justify-content-between align-items-center text-success promo-discount">
                            <div class="d-flex align-items-center gap-2">
                                <i class="mdi mdi-ticket-percent"></i>
                                <span>Cupón: ${promoCode}</span>
                            </div>
                            <span>- ${SIWReserva.utils.formatCurrency(promoDiscount)}</span>
                        </li>
                    `);
                }
            },

            /**
             * Carga resumen completo
             */
            loadCompleteSummary: function() {
                this.loadBasePrice();
                this.loadExtras();
                this.loadPromoDiscount();
            }
        },

        // =================================================
        // EXTRAS MANAGER - GESTIÓN DE EXTRAS
        // =================================================
        extrasManager: {
            /**
             * Carga extras disponibles desde el backend
             */
            loadAvailableExtras: function(servicioId) {
                const extrasContainer = $('.extras-container');
                extrasContainer.html('<div class="text-center py-4"><div class="spinner-border text-primary" role="status"></div><p class="mt-2">Cargando extras disponibles...</p></div>');

                $.ajax({
                    url: API_ROUTES.getExtrasRequest,
                    method: 'POST',
                    data: { 'servicioId': servicioId },
                    success: function(response) {
                        if (!response || !Array.isArray(response.extras) || response.extras.length === 0) {
                            extrasContainer.html('<div class="alert alert-info">No hay extras disponibles para esta actividad.</div>');
                            return;
                        }

                        extrasContainer.empty();

                        response.extras.forEach((extra, index) => {
                            const nombre = extra.nombre || '';
                            const precio = extra.precio || 0;
                            const precioFormateado = precio + ' EUR';
                            const descripcion = extra.descripcion || '';

                            const extraHTML = `
                                <div class="card mb-3 border-0 shadow-sm" data-extra-id="${extra.id}">
                                    <div class="card-body d-flex justify-content-between align-items-center">
                                        <div>
                                            <strong class="card-title">${nombre}</strong>
                                            <p class="mb-0 text-muted price-tag">${precioFormateado}</p>
                                        </div>
                                        <div class="input-step step-secondary">
                                            <button type="button" class="extras-minus">–</button>
                                            <input id="extras-${extra.id}" type="number" class="product-quantity" value="0" min="0" max="10" readonly="">
                                            <button type="button" class="extras-plus">+</button>
                                        </div>
                                    </div>
                                </div>`;
                            extrasContainer.append(extraHTML);
                        });

                        $('.extra-card').addClass('animate__animated animate__fadeIn');
                    },
                    error: function(xhr) {
                        SIWReserva.utils.handleError(xhr.responseText || xhr.statusText, 'extrasManager.loadAvailableExtras');
                        extrasContainer.html('<div class="alert alert-danger">Error al cargar los extras. Inténtalo nuevamente.</div>');
                    }
                });
            },

            /**
             * Actualiza un extra
             */
            updateExtra: function(extraId, extraName, extraPrice, quantity) {
                // Validar datos del extra
                if (!extraName || extraName.trim() === '') {
                    const cardElement = $(`.card[data-extra-id="${extraId}"]`);
                    if (cardElement.length) {
                        extraName = cardElement.find('.card-title').text().trim();
                    }
                }

                if (!extraPrice || extraPrice.trim() === '') {
                    const cardElement = $(`.card[data-extra-id="${extraId}"]`);
                    if (cardElement.length) {
                        extraPrice = cardElement.find('.price-tag').text().trim();
                    }
                }

                // Delegar a summaryManager
                SIWReserva.summaryManager.updateExtra(extraId, extraName, extraPrice, quantity);
            }
        },

        // =================================================
        // PROMO MANAGER - GESTIÓN DE PROMOCIONES
        // =================================================
        promoManager: {
            /**
             * Aplica código promocional
             */
            apply: function(promoCode, callback) {
                if (!promoCode) {
                    if (typeof callback === 'function') {
                        callback(false, 'Por favor, introduce un código promocional.');
                    }
                    return;
                }

                const totals = SIWReserva.priceManager.calculateTotals();
                const subtotalConExtras = totals.baseTotal + totals.extrasTotal;

                $.ajax({
                    url: API_ROUTES.validateCoupon,
                    method: 'POST',
                    data: {
                        coupon_code: promoCode,
                        total_amount: subtotalConExtras
                    },
                    success: function(response) {
                        if (response.success) {
                            const discount = response.coupon.discount_amount;

                            SIWReserva.storage.set('promoCode', promoCode);
                            SIWReserva.storage.set('promoDiscount', discount);
                            SIWReserva.storage.set('promoCoupon', response.coupon);

                            SIWReserva.summaryManager.loadPromoDiscount();
                            SIWReserva.priceManager.updateTotalsUI();

                            if (typeof callback === 'function') {
                                callback(true, discount.toFixed(2));
                            }
                        } else {
                            if (typeof callback === 'function') {
                                callback(false, response.message || 'Código promocional no válido.');
                            }
                        }
                    },
                    error: function(xhr) {
                        let errorMessage = 'Error al aplicar el código promocional. Inténtalo de nuevo.';

                        if (xhr.responseJSON && xhr.responseJSON.message) {
                            errorMessage = xhr.responseJSON.message;
                        }

                        if (typeof callback === 'function') {
                            callback(false, errorMessage);
                        }
                    }
                });
            },

            /**
             * Limpia código promocional
             */
            clear: function() {
                SIWReserva.storage.remove('promoCode');
                SIWReserva.storage.remove('promoDiscount');

                $('#promo-code').val('').prop('disabled', false);
                $('.apply-promo').text('Aplicar').prop('disabled', false);
                $('.remove-promo').addClass('d-none');
                $('.promo-feedback').addClass('d-none');

                SIWReserva.summaryManager.loadPromoDiscount();
                SIWReserva.priceManager.updateTotalsUI();
            },

            /**
             * Muestra feedback de promoción
             */
            showFeedback: function(message, type) {
                $('.promo-feedback').addClass('d-none');
                $(`.promo-feedback.text-${type === 'success' ? 'success' : 'danger'}`)
                    .removeClass('d-none')
                    .find('span').text(message);
            },

            restore: function() {
                const promoCode = SIWReserva.storage.get('promoCode', '');
                const promoDiscount = parseFloat(SIWReserva.storage.get('promoDiscount', 0));

                if (promoCode && promoDiscount > 0) {
                    const promoInput = $('#promo-code');
                    const button = $('.apply-promo');

                    promoInput.val(promoCode).prop('disabled', true);
                    button.text('Limpiar').removeClass('btn-outline-secondary').addClass('btn-danger').prop('disabled', false);
                    $('#promo-discount').text(promoDiscount.toFixed(2) + ' EUR');
                    $('.promo-feedback.text-success').removeClass('d-none');
                    $('.promo-feedback.text-danger').addClass('d-none');
                }
            },
        },

        // =================================================
        // FORM VALIDATOR - VALIDACIÓN DE FORMULARIOS
        // =================================================
        formValidator: {
            /**
             * Valida formulario de pago
             */
            validatePaymentForm: function() {
                let isValid = true;

                $('.is-invalid').removeClass('is-invalid');
                $('.invalid-feedback').remove();

                const fields = [
                    { id: 'nombre', msg: 'Por favor, introduce tu nombre' },
                    { id: 'apellidos', msg: 'Por favor, introduce tus apellidos' },
                    { id: 'email', msg: 'Por favor, introduce tu email' },
                    { id: 'telefono', msg: 'Por favor, introduce tu teléfono' }
                ];

                fields.forEach(field => {
                    if (!$('#' + field.id).val().trim()) {
                        $('#' + field.id).addClass('is-invalid')
                            .after(`<div class="invalid-feedback">${field.msg}</div>`);
                        isValid = false;
                    }
                });

                // Validación específica de email
                const email = $('#email').val().trim();
                if (email && !config.validation.email.test(email)) {
                    $('#email').addClass('is-invalid')
                        .after('<div class="invalid-feedback">Por favor, introduce un email válido</div>');
                    isValid = false;
                }

                // Validación específica de teléfono
                const telefono = $('#telefono').val().trim();
                if (telefono && !config.validation.phone.test(telefono)) {
                    $('#telefono').addClass('is-invalid')
                        .after('<div class="invalid-feedback">Por favor, introduce un número de teléfono válido</div>');
                    isValid = false;
                }

                return isValid;
            },

            /**
             * Valida datos críticos de la reserva
             */
            validateCriticalData: function() {
                const errors = [];

                // Validar modalidad
                const modalidad = SIWReserva.storage.get('modalidad');
                if (![
                    'PRIVADA',
                    'COMPARTIDA',
                    'GRUPAL X2',
                    'GRUPAL X3',
                    'GRUPAL X4',
                    'GRUPAL X5',
                    'GRUPAL X6',
                    'PRIVATE',
                    'SHARE',
                    'SHARED',
                    'GROUP X2',
                    'GROUP X3',
                    'GROUP X4',
                    'GROUP X5',
                    'GROUP X6',
                    'MULTI X2',
                    'MULTI X3',
                    'MULTI X4',
                    'MULTI X5',
                    'MULTI X6',
                    'Multi x2',
                    'Multi x3',
                    'Multi x4',
                    'Multi x5',
                    'Multi x6',
                    'Privada',
                    'Compartida',
                    'Grupal x2',
                    'Grupal x3',
                    'Grupal x4',
                    'Grupal x5',
                    'Grupal x6',
                    'Private',
                    'Share',
                    'Shared',
                    'Group x2',
                    'Group x3',
                    'Group x4',
                    'Group x5',
                    'Group x6',

                    'privada',
                    'compartida',
                    'grupal x2',
                    'grupal x3',
                    'grupal x4',
                    'grupal x5',
                    'grupal x6',
                    'private',
                    'share',
                    'shared',
                    'group x2',
                    'group x3',
                    'group x4',
                    'group x5',
                    'group x6',
                    'multi x2',
                    'multi x3',
                    'multi x4',
                    'multi x5',
                    'multi x6',
                    'multi x2',
                    'multi x3',
                    'multi x4',
                    'multi x5',
                    'multi x6',
                    'privada',
                    'compartida',
                    'grupal x2',
                    'grupal x3',
                    'grupal x4',
                    'grupal x5',
                    'grupal x6',
                    'private',
                    'share',
                    'shared',
                    'group x2',
                    'group x3',
                    'group x4',
                    'group x5',
                    'group x6',
                ].includes(modalidad)) {
                    errors.push('La modalidad seleccionada no es válida.');
                }

                // Validar hora
                const selectedHour = SIWReserva.storage.get('selectedHour');
                if (selectedHour === 'on' || selectedHour === 'off' || !config.validation.time.test(selectedHour)) {
                    errors.push('La hora seleccionada no es válida.');
                }

                // Validar IDs importantes
                const servicioId = SIWReserva.storage.get('servicio_id');
                const vehiculoId = SIWReserva.storage.get('vehiculo_id');
                const ofertaId = SIWReserva.storage.get('oferta_id');

                if (!servicioId) errors.push('No se ha seleccionado un servicio válido.');
                //if (!vehiculoId) errors.push('No se ha seleccionado un vehículo válido.');
                if (!ofertaId) errors.push('No se ha seleccionado una oferta válida.');

                if (errors.length > 0) {

                    SIW.Reserva.utils.log('Errores de validación crítica: ' + errors.join(', '), 'error', 'formValidator');
                    SIW.Reserva.utils.log('Argumentos Comprobados:', 'error', 'formValidator');
                    SIW.Reserva.utils.log('    - modalidad    ->> ' +  modalidad, 'error', 'formValidator');
                    SIW.Reserva.utils.log('    - selectedHour ->> ' + selectedHour, 'error', 'formValidator');
                    SIW.Reserva.utils.log('    - servicioId   ->> ' + servicioId, 'error', 'formValidator');
                    SIW.Reserva.utils.log('    - vehiculoId   ->> ' +  vehiculoId, 'error', 'formValidator');
                    SIW.Reserva.utils.log('    - ofertaId     ->> ' +  ofertaId, 'error', 'formValidator');

                    return false;
                }

                return true;
            },

            /**
             * Carga datos guardados del cliente
             */
            loadSavedClientData: function() {
                const savedClientData = SIWReserva.storage.get('clientData', {});

                if (savedClientData.nombre) $('#nombre').val(savedClientData.nombre);
                if (savedClientData.apellidos) $('#apellidos').val(savedClientData.apellidos);
                if (savedClientData.email) $('#email').val(savedClientData.email);
                if (savedClientData.telefono) $('#telefono').val(savedClientData.telefono);
            }
        },

        // =================================================
        // PAYMENT PROCESSOR - PROCESAMIENTO DE PAGOS
        // =================================================
        paymentProcessor: {
            /**
             * Procesa el pago
             */
            process: function() {
                if (!SIWReserva.formValidator.validatePaymentForm()) {
                    SIWReserva.utils.scrollTo('.is-invalid:first', 100);
                    return false;
                }

                if (!SIWReserva.formValidator.validateCriticalData()) {
                    this.showError('Los datos de la reserva no son válidos. Por favor, vuelve a seleccionar una oferta.');
                    return false;
                }

                SIWReserva.utils.toggleLoading('#bookNow-pay', true);

                this.collectFormData()
                    .then(formData => {
                        return fetch(API_ROUTES.processBooking, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
                            },
                            body: JSON.stringify(formData)
                        });
                    })
                    .then(response => {
                        return response.text().then(text => {
                            if (text.trim() === '') {
                                const vacio = new Error('Empty response from server');
                                vacio.kind = 'empty';
                                vacio.httpStatus = response.status;
                                throw vacio;
                            }

                            try {
                                return JSON.parse(text);
                            } catch (e) {
                                const invalido = new Error('Invalid JSON from server');
                                invalido.kind = 'invalid_response';
                                invalido.httpStatus = response.status;
                                invalido.body = text.slice(0, 500);
                                throw invalido;
                            }
                        });
                    })
                    .then(data => {
                        // Casos de éxito
                        if (data.success && data.payment_data) {
                            this.submitToRedsys(data.payment_data);
                        } else if (data.success && data.tipo === 'reserva_gratuita') {
                            SIWReserva.utils.redirect(data.redirect_url);
                        } else if (data.success && data.confirmationUrl) {
                            SIWReserva.utils.redirect(data.confirmationUrl);
                        }
                        // Casos de error específicos
                        else if (data.error_type === 'session') {
                            const originalUrl = sessionStorage.getItem('originalBookingURL');
                            if (originalUrl) {
                                SIWReserva.utils.redirect(originalUrl);
                            } else {
                                SIWReserva.utils.redirect(API_ROUTES.renderSelection);
                            }
                        } else if (data.error_type === 'security') {
                            SIWReserva.utils.redirect(API_ROUTES.renderBookingBase + '/0', true);
                        } else if (data.error_type === 'reservation_creation' || data.error_type === 'payment_init') {
                            this.showErrorModal(data.message || 'Error del servidor. Por favor, inténtalo de nuevo.');
                        } else if (data.errors) {
                            this.showValidationErrors(data.errors);
                        } else {
                            this.showError('Error inesperado. Por favor, inténtalo de nuevo.');
                        }
                    })
                    .catch(error => {
                        console.error('processBooking error:', error, error && error.body ? error.body : '');
                        this.showErrorModal(this.describeProcessError(error));
                    });

                return true;
            },

            /**
             * Texto para el usuario según el tipo de fallo de processBooking
             * (red caída, sesión caducada, HTTP 5xx, respuesta no JSON, error de JS).
             */
            describeProcessError: function(error) {
                const status = error && error.httpStatus ? error.httpStatus : null;
                const ref = status ? ' (HTTP ' + status + ')' : '';

                if (status === 419) {
                    return 'La sesión ha caducado. Recarga la página y vuelve a intentarlo.';
                }
                if (status === 429) {
                    return 'Demasiadas peticiones seguidas. Espera un momento e inténtalo de nuevo.';
                }
                if (status === 403) {
                    return 'No hemos podido validar tu solicitud' + ref + '. Recarga la página e inténtalo de nuevo.';
                }
                if (status >= 500) {
                    return 'El servidor ha tenido un problema' + ref + '. Inténtalo de nuevo en unos minutos.';
                }
                if (error && (error.kind === 'empty' || error.kind === 'invalid_response')) {
                    return 'El servidor ha devuelto una respuesta inesperada' + ref + '. Inténtalo de nuevo.';
                }
                if (error instanceof TypeError && /fetch|network|load failed/i.test(error.message || '')) {
                    return 'Error de conexión. Verifica tu conexión a internet.';
                }
                return 'Ha ocurrido un error inesperado. Recarga la página e inténtalo de nuevo.';
            },

            submitToRedsys: function(paymentData) {
                window.siw_consola('paymentData:', paymentData);

                const form = document.createElement('form');
                form.method = 'POST';
                form.action = paymentData.action_url;
                form.style.display = 'none';

                // Crear campos hidden
                const fields = {
                    'Ds_SignatureVersion': paymentData.signature_version,
                    'Ds_MerchantParameters': paymentData.merchant_parameters,
                    'Ds_Signature': paymentData.signature
                };

                Object.keys(fields).forEach(key => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = fields[key];
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
            },

            /**
             * Recopila datos del formulario
             */
            collectFormData: function() {
                // 1. Sincronizar datos del cliente al localStorage
                SIWReserva.storage.set('clientData', {
                    nombre: $('#nombre').val().trim(),
                    apellidos: $('#apellidos').val().trim(),
                    email: $('#email').val().trim(),
                    telefono: $('#telefono').val().trim()
                });

                // 2. Recopilar localStorage actualizado
                const todoLocalStorage = {};
                for (let i = 0; i < sessionStorage.length; i++) {
                    const key = sessionStorage.key(i);
                    todoLocalStorage[key] = SIWReserva.storage.get(key);
                }

                // 3. Obtener sessionId
                const sessionId = SIWReserva.storage.get('sessionId');

                if (!sessionId) {
                    throw new Error('SessionId no encontrado');
                }

                return Promise.resolve({
                    nombre: $('#nombre').val().trim(),
                    apellidos: $('#apellidos').val().trim(),
                    email: $('#email').val().trim(),
                    telefono: $('#telefono').val().trim(),
                    sessionId: sessionId,
                    localStorageData: todoLocalStorage,
                    simulate_error: false
                });
            },

            /**
             * Normaliza datos para generar hash consistente (igual que PHP)
             */
            normalizeDataForHash: function(data) {
                // Extraer solo campos críticos y normalizarlos
                const criticalFields = {
                    'fecha': this.sanitizeAlphaNumeric(String(data.fecha || '')),
                    'selectedHour': this.sanitizeAlphaNumeric(String(data.selectedHour || '')),
                    'peopleCount': parseInt(data.peopleCount || 0),
                    'modalidad': this.sanitizeAlphaNumeric(String(data.modalidad || '')),
                    'servicio_id': parseInt(data.servicio_id || 0),
                    'vehiculo_id': parseInt(data.vehiculo_id || 0),
                    'titulo': this.sanitizeAlphaNumeric(String(data.titulo || '')),
                    'ciudad': this.sanitizeAlphaNumeric(String(data.ciudad || '')),
                };

                // Ordenar por clave para consistencia
                const sortedKeys = Object.keys(criticalFields).sort();

                // Crear string determinista SOLO con alfanuméricos
                let hashString = '';
                sortedKeys.forEach(key => {
                    const cleanKey = this.sanitizeAlphaNumeric(key);
                    hashString += cleanKey + criticalFields[key];
                });

                return hashString;
            },

            /**
             * Sanitiza string - SOLO letras inglesas y números
             */
            sanitizeAlphaNumeric: function(string) {
                // Quitar todo excepto a-z, A-Z, 0-9
                return string.replace(/[^a-zA-Z0-9]/g, '');
            },

            /**
             * Muestra error en el formulario
             */
            showError: function(message) {
                $('.form-error-message').remove();
                $('<div class="alert alert-danger form-error-message mt-3">' + message + '</div>').insertBefore('#bookNow-pay');
                SIWReserva.utils.scrollTo('.form-error-message', 100);
            },

            showErrorModal: function(message) {
                $('.form-error-message').remove();
                const orig = $('#bookNow-pay').data('orig-html');
                if (orig) {
                    SIWReserva.utils.toggleLoading('#bookNow-pay', false, orig);
                }
                if (typeof swal === 'function') {
                    swal({
                        icon: 'error',
                        title: 'Error',
                        text: message
                    });
                } else {
                    this.showError(message);
                }
            }
        },

        // =================================================
        // FASES - ENTRY POINTS POR FASE (EXTENDIDO)
        // =================================================
        fases: {
            /**
             * Inicialización de la fase de booking
             */
            booking: function() {
                SIWReserva.utils.loader('loading');

                // Limpiar datos de sesión
                SIWReserva.storage.clear(['debug', 'config']);

                // Cargar ciudades
                const cityParam = SIWReserva.utils.getUrlParameter('city');
                SIWReserva.fases.loadInitialData(cityParam);
                SIWReserva.fases.loadCities(cityParam);

                // Configurar eventos de booking
                SIWReserva.fases.setupBookingEvents();

                // Configurar contador AJAX
                SIWReserva.fases.setupAjaxCounter();
            },

            /**
             * Inicialización de la fase de extras
             */
            extras: function() {
                SIWReserva.utils.loader('loading');

                // Verificar datos de reserva
                if (!SIWReserva.storage.get('fecha') || !SIWReserva.storage.get('selectedHour')) {
                    SIWReserva.utils.redirect(window.bbb.config['URL Fallback Redirection'], true);
                    return;
                }

                // Inicializar selectedExtras SI NO EXISTE
                if (!SIWReserva.storage.exists('selectedExtras')) {
                    SIWReserva.storage.set('selectedExtras', []);
                }

                // Preservar datos críticos
                const datosReserva = {
                    selectedHour: SIWReserva.storage.get('selectedHour'),
                    peopleCount: SIWReserva.storage.get('peopleCount'),
                    modalidad: SIWReserva.storage.get('modalidad'),
                    fecha: SIWReserva.storage.get('fecha'),
                    precio: SIWReserva.storage.get('precio', []),
                    titulo: SIWReserva.storage.get('titulo'),
                    ciudad: SIWReserva.storage.get('ciudad'),
                    ciudadDescriptiva: SIWReserva.storage.get('ciudadDescriptiva'),
                    servicio_id: SIWReserva.storage.get('servicio_id'),
                    vehiculo_id: SIWReserva.storage.get('vehiculo_id'),
                    oferta_id: SIWReserva.storage.get('oferta_id')
                };

                // Cargar datos
                SIWReserva.priceManager.updateTotalsUI();
                SIWReserva.summaryManager.loadBasicSummary();
                SIWReserva.extrasManager.loadAvailableExtras(datosReserva.servicio_id);
                SIWReserva.summaryManager.loadBasePrice();

                // Restaurar datos críticos
                Object.keys(datosReserva).forEach(key => {
                    SIWReserva.storage.set(key, datosReserva[key]);
                });

                // Mostrar oferta seleccionada
                SIWReserva.fases.showSelectedOffer();

                // Configurar eventos de extras
                SIWReserva.fases.setupExtrasEvents();

                // Configurar contador AJAX
                SIWReserva.fases.setupAjaxCounter();

                SIWReserva.utils.log('Página de extras cargada', 'info', 'extras.blade');

                // Verificar que tenemos datos de reserva válidos
                const fecha = SIWReserva.storage.get('fecha');
                const selectedHour = SIWReserva.storage.get('selectedHour');

                if (!fecha || !selectedHour) {
                    SIWReserva.utils.log('Datos de reserva incompletos, redirigiendo a booking', 'warn', 'extras.blade');
                    alert('No se encontraron datos de reserva válidos. Serás redirigido a la página de reserva.');
                    SIWReserva.utils.redirect(window.bbb.config['URL Fallback Redirection'], true);
                    return;
                }

                $('.book-now-topay').off('click').on('click', function() {
                    const selectedExtras = SIWReserva.storage.get('selectedExtras', []);
                    const extrasCount = selectedExtras.filter(extra => extra.quantity > 0).length;

                    if (extrasCount === 0) {
                        window.location.href = API_ROUTES.renderPayment;
                    } else {
                        SIWReserva.utils.log(`Continuando con ${extrasCount} extras seleccionados`, 'info', 'extras.blade');
                        window.location.href = API_ROUTES.renderPayment;
                    }
                });

                // Verificación del sistema (opcional - para debugging)
                if (SIWReserva.getConfig().debug) {
                    SIWReserva.utils.log('=== VERIFICACIÓN EXTRAS ===','info','Extras');
                    SIWReserva.utils.log('✅ SIWReserva:' + window.SIW && window.SIW.Reserva ? '✅' : '❌','info','Extras');
                    SIWReserva.utils.log('✅ Fecha reserva:' + SIWReserva.storage.get('fecha'),'info','Extras');
                    SIWReserva.utils.log('✅ Hora reserva:' + SIWReserva.storage.get('selectedHour'),'info','Extras');
                    SIWReserva.utils.log('✅ Servicio ID:' + SIWReserva.storage.get('servicio_id'),'info','Extras');
                    SIWReserva.utils.log('✅ Extras actuales:' + SIWReserva.storage.get('selectedExtras', []),'info','Extras');
                    SIWReserva.utils.log('===========================');
                }

            },

            /**
             * Inicialización de la fase de payment
             */
            payment: function() {
                SIWReserva.utils.loader('loading');

                // Verificar datos de reserva
                if (!SIWReserva.storage.get('fecha') || !SIWReserva.storage.get('selectedHour')) {
                    SIWReserva.utils.redirect(window.bbb.config['URL Fallback Redirection'], true);
                    return;
                }

                if (!SIWReserva.storage.get('fecha') || !SIWReserva.storage.get('selectedHour')) {
                    SIWReserva.utils.redirect(window.bbb.config['URL Fallback Redirection'], true);
                    return;
                }

                // Cargar datos
                SIWReserva.summaryManager.loadBasicSummary();
                SIWReserva.promoManager.restore();
                SIWReserva.priceManager.updateTotalsUI();
                SIWReserva.summaryManager.loadCompleteSummary();

                // Cargar datos del cliente
                SIWReserva.formValidator.loadSavedClientData();

                // Mostrar oferta seleccionada
                SIWReserva.fases.showSelectedOffer();

                // Configurar eventos de payment
                SIWReserva.fases.setupPaymentEvents();

                // Configurar contador AJAX
                SIWReserva.fases.setupAjaxCounter();

                // Verificar que tenemos datos de reserva válidos
                const fecha = SIWReserva.storage.get('fecha');
                const selectedHour = SIWReserva.storage.get('selectedHour');
                const modalidad = SIWReserva.storage.get('modalidad');

                if (!fecha || !selectedHour || !modalidad) {
                    SIWReserva.utils.log('Datos de reserva incompletos, redirigiendo a booking', 'warn', 'payment.blade');
                    alert('No se encontraron datos de reserva válidos. Serás redirigido a la página de reserva.');
                    SIWReserva.utils.redirect(window.bbb.config['URL Fallback Redirection'], true);
                    return;
                }

                $('#nombre, #apellidos, #email, #telefono').on('blur', function() {
                    const field = $(this);
                    const value = field.val().trim();

                    // Limpiar errores previos
                    field.removeClass('is-invalid');
                    field.next('.invalid-feedback').remove();

                    // Validar campo específico
                    let isValid = true;
                    let errorMessage = '';

                    if (!value) {
                        isValid = false;
                        errorMessage = 'Este campo es obligatorio';
                    } else if (field.attr('id') === 'email' && !SIWReserva.getConfig().validation.email.test(value)) {
                        isValid = false;
                        errorMessage = 'Por favor, introduce un email válido';
                    } else if (field.attr('id') === 'telefono' && !SIWReserva.getConfig().validation.phone.test(value)) {
                        isValid = false;
                        errorMessage = 'Por favor, introduce un número de teléfono válido';
                    }

                    if (!isValid) {
                        field.addClass('is-invalid');
                        field.after(`<div class="invalid-feedback">${errorMessage}</div>`);
                    }
                });

                if (SIWReserva.getConfig().debug) {
                    //window.siw_consola('=== VERIFICACIÓN PAYMENT ===');
                    //window.siw_consola('✅ SIWReserva:', window.SIW && window.SIW.Reserva ? '✅' : '❌');
                    //window.siw_consola('✅ Fecha reserva:', SIWReserva.storage.get('fecha'));
                    //window.siw_consola('✅ Hora reserva:', SIWReserva.storage.get('selectedHour'));
                    //window.siw_consola('✅ Modalidad:', SIWReserva.storage.get('modalidad'));
                    //window.siw_consola('✅ Extras seleccionados:', SIWReserva.storage.get('selectedExtras', []));
                    //window.siw_consola('✅ Datos cliente guardados:', SIWReserva.storage.get('clientData', {}));
                    //window.siw_consola('============================');
                }

            },

            // =================================================
            // MÉTODOS AUXILIARES DE FASES
            // =================================================

            /**
             * Carga ciudades disponibles
             */
            loadCities: function(cityParam = null) {
                if (this._loadingCities) return;
                this._loadingCities = true;

                const citySelect = $('#city');
                const currentCity = citySelect.val();

                citySelect.prop('disabled', true);
                citySelect.html('<option value="">Esperando Ciudades...</option>');

                $.ajax({
                    url: API_ROUTES.getCities,
                    method: 'POST',
                    success: function(response) {
                        if (response.success && Array.isArray(response.cities)) {
                            citySelect.empty();
                            citySelect.append('<option value="">Seleccione una ciudad</option>');

                            $.each(response.cities, function(index, ciudad) {
                                const option = $('<option></option>')
                                    .attr('value', ciudad.code)
                                    .text(ciudad.nombre);

                                if ((cityParam && ciudad.code === cityParam) ||
                                    (!cityParam && ciudad.code === currentCity)) {
                                    option.prop('selected', true);
                                }

                                citySelect.append(option);
                            });

                            if (!citySelect.val()) {
                                citySelect.find('option[value="bcn"]').prop('selected', true);
                                if (!citySelect.val() && response.cities.length > 0) {
                                    citySelect.find('option:eq(1)').prop('selected', true);
                                }
                            }

                            citySelect.prop('disabled', cityParam ? true : false);
                        } else {
                            citySelect.empty();
                            citySelect.append('<option value="">No hay ciudades disponibles</option>');

                            if (cityParam) {
                                citySelect.val(cityParam);
                                citySelect.prop('disabled', true);
                            } else {
                                citySelect.val('bcn');
                                citySelect.prop('disabled', false);
                            }
                        }
                    },
                    error: function(xhr) {
                        SIWReserva.utils.handleError(xhr.responseText || xhr.statusText, 'fases.loadCities');

                        citySelect.empty();
                        citySelect.append('<option value="">Sin Ciudades Disponibles - Err</option>');
                        if (cityParam) {
                            citySelect.val(cityParam);
                            citySelect.prop('disabled', true);
                        } else {
                            citySelect.val('bcn');
                            citySelect.prop('disabled', false);
                        }
                    }
                }).always(() => {
                    this._loadingCities = false;
                });
            },

            /**
             * Carga datos iniciales de la ciudad
             */

            loadInitialData: function(selectedCity) {
                if (this._loadingInitialData) return;
                this._loadingInitialData = true;

                $.ajax({
                    url: API_ROUTES.getInitialData,
                    method: 'POST',
                    data: { city: selectedCity, tv: window.SIW_CONFIG.VEHICLE_TYPE },
                    beforeSend: function() {
                        $('#loading-galeria').show().siblings('#image-gallery').find('img').attr('src', '');
                    },
                    success: function(response) {
                        // Verificar si hay error (ciudad no encontrada)
                        if (response.error === true) {
                            SIWReserva.utils.showContactForm(selectedCity, response.images, response.titulo, response.descripcion);
                            return;
                        }

                        if (!response || typeof response !== 'object') return;

                        const topSection = response.topSection;
                        const detailsSection = response.detailsSection;

                        if (!topSection || !detailsSection) {
                            SIWReserva.utils.showContactForm(selectedCity);
                            return;
                        }

                        // Actualizar información de la ciudad
                        $('#dynamic-city').text(topSection.ciudad);
                        $('#dynamic-title').text(topSection.titulo);
                        $('#dynamic-city-info').text(topSection.ciudad);
                        $('#dynamic-guide-info').text(topSection.guia);
                        $('#dynamic-map-link').attr('href', topSection.rutas_disponibles);
                        // Nota ruta
                        if (topSection.nota_ruta_visible && topSection.nota_ruta) {
                            $('#nota-ruta-texto').html(topSection.nota_ruta);
                            $('#nota-ruta-container').show();
                        } else {
                            $('#nota-ruta-container').hide();
                        }
                        $('#dynamic-description').text(topSection.descripcion);

                        // Actualizar imagen thumbnail
                        $('#image-thumbnail').attr('src', topSection.image);

                        // Actualizar estrellas
                        const estrellas = Math.min(Math.round(topSection.estrellas), 5);
                        const estrellasBlancas = 5 - estrellas;
                        const starsHtml =
                            Array(estrellas).fill('<span class="mdi mdi-star text-warning"></span>').join('') +
                            Array(estrellasBlancas).fill('<span class="mdi mdi-star-outline text-muted"></span>').join('');

                        $('#dynamic-reviews').html(starsHtml);
                        $('#dynamic-review-count').text(`(${topSection.reviews} Reseñas)`);

                        // Actualizar imágenes de la galería
                        const images = topSection.images;
                        SIWReserva.utils.renderGallery(images);

                        // Actualizar detalles
                        const detailsContainer = $('#dynamic-details');
                        detailsContainer.empty();

                        // Si detailsSection viene de un data-attribute o un response sin parsear:
                        const detailsSectiondata = typeof detailsSection === 'string' ? JSON.parse(detailsSection) : detailsSection;

                        $.each(detailsSectiondata, (index, detail) => {
                            const detailHTML = `
                            <div class="detail-item">
                                <dt><i class="${detail.icon}"></i> ${detail.title}</dt>
                                <dd>${detail.description}</dd>
                            </div>
                        `;
                            $(detailsContainer).append(detailHTML);
                        });


                        // Actualizar detalles adicionales
                        const additionalDetails = response.additionalDetailsSection;
                        const additionalContainer = $('#dynamic-additional-details');
                        const additionalSection = $('#additional-details-container');

                        if (additionalDetails && additionalDetails.length > 0) {
                            additionalContainer.empty();


                            // Asegúrate de parsear si viene como String
                            const additionalDetailsdata = typeof additionalDetails === 'string' ? JSON.parse(additionalDetails) : additionalDetails;

                            $.each(additionalDetailsdata, (index, item) => {
                                const detailHTML = `
                                <div class="detail-item">
                                    <dt><i class="${item.icon}"></i> ${item.title}</dt>
                                    <dd>${item.description}</dd>
                                </div>
                            `;
                                $(additionalContainer).append(detailHTML);
                            });

                            additionalSection.show(); // Mostrar la sección
                        } else {
                            additionalSection.hide(); // Ocultar si no hay datos
                        }

                        // Ocultar loading cuando todo esté listo
                        $('#loading-galeria').hide();
                    },

                    error: function(xhr) {
                        SIWReserva.utils.showContactForm(selectedCity, []);
                    }
                }).always(() => {
                    this._loadingInitialData = false;
                });
            },

            /**
             * Muestra la oferta seleccionada
             */
            showSelectedOffer: function() {
                if ($('#selected-offer').length > 0) {
                    const selectedOffer = {
                        title: SIWReserva.storage.get('titulo',''),
                        date: SIWReserva.storage.get('fecha',''),
                        hour: SIWReserva.storage.get('selectedHour',''),
                        hourEnd: SIWReserva.storage.get('hora_fin',''),
                        image: SIWReserva.storage.get('image',''),
                        ciudad: SIWReserva.storage.get('ciudadDescriptiva',''),
                    };

                    // Construir texto de horario
                    const horarioTexto = selectedOffer.hourEnd ?
                        `${selectedOffer.hour} - ${selectedOffer.hourEnd}` :
                        selectedOffer.hour;

                    $('#selected-offer').html(`
                        <img src="${selectedOffer.image}" class="rounded me-3 to64" alt="Imagen del tour">
                        <div>
                            <h6 class="mb-0 fw-bold">${selectedOffer.title}</h6>
                            <p class="text-muted mb-0">${selectedOffer.ciudad}: ${selectedOffer.date}, ${horarioTexto}</p>
                        </div>
                    `);
                }
            },

            /**
             * Actualiza UI con datos de la reserva
             */
            updateBookingUI: function(booking) {
                $('#activity-name').text(booking.titulo || SIWReserva.storage.get('titulo', 'S/I'));
                $('#booking-date').text(booking.fecha || SIWReserva.storage.get('fecha'));
                $('#booking-time').text(booking.hora || SIWReserva.storage.get('selectedHour'));
                $('#booking-duration').text(`${booking.duracion || SIWReserva.storage.get('duracion')} minutos`);
                $('#booking-modality').text(booking.modalidad || SIWReserva.storage.get('modalidad'));
                $('#booking-participants').text(booking.participantes || SIWReserva.storage.get('peopleCount'));
                $('#meeting-point').text(booking.punto_encuentro || `Av. del Litoral, 30, ${SIWReserva.storage.get('ciudadDescriptiva')}`);

                // Mostrar extras si existen
                if (booking.extras && booking.extras.length > 0) {
                    const extrasContainer = $('#booking-extras');
                    extrasContainer.empty();

                    booking.extras.forEach(extra => {
                        extrasContainer.append(`
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span>${extra.quantity} x ${extra.name}</span>
                                <span class="badge bg-primary rounded-pill">${SIWReserva.utils.formatCurrency(extra.price * extra.quantity)}</span>
                            </li>
                        `);
                    });

                    $('#extras-section').removeClass('d-none');
                }

                $('#total-paid').text(SIWReserva.utils.formatCurrency(booking.total || SIWReserva.priceManager.calculateTotals().finalTotal));
            },

            /**
             * Carga datos de reserva desde localStorage (fallback)
             */
            loadBookingFromLocalStorage: function() {
                const clientData = SIWReserva.storage.get('clientData', {});
                const selectedHour = SIWReserva.storage.get('selectedHour', '');
                const modalidad = SIWReserva.storage.get('modalidad', '');
                const duracion = SIWReserva.storage.get('duracion', '');
                const participantes = SIWReserva.storage.get('peopleCount', '');
                const fecha = SIWReserva.storage.get('fecha', '');
                const ciudadDescriptiva = SIWReserva.storage.get('ciudadDescriptiva', '');
                const titulo = SIWReserva.storage.get('titulo', '');

                $('#activity-name').text(titulo);
                $('#booking-date').text(fecha);
                $('#booking-time').text(selectedHour);
                $('#booking-duration').text(`${duracion} minutos`);
                $('#booking-modality').text(modalidad === 'PRIVATE' ? 'Privada' : 'Compartida');
                $('#booking-participants').text(participantes);
                $('#meeting-point').text(`Av. del Litoral, 30, ${ciudadDescriptiva}`);

                // Mostrar extras
                const selectedExtras = SIWReserva.storage.get('selectedExtras', []);
                if (selectedExtras.length > 0) {
                    const extrasContainer = $('#booking-extras');
                    extrasContainer.empty();

                    selectedExtras.forEach(extra => {
                        if (extra.quantity > 0) {
                            extrasContainer.append(`
                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    <span>${extra.quantity} x ${extra.name}</span>
                                    <span class="badge bg-primary rounded-pill">${SIWReserva.utils.formatCurrency(SIWReserva.utils.parsePrice(extra.price) * extra.quantity)}</span>
                                </li>
                            `);
                        }
                    });

                    $('#extras-section').removeClass('d-none');
                }

                const totals = SIWReserva.priceManager.calculateTotals();
                $('#total-paid').text(SIWReserva.utils.formatCurrency(totals.finalTotal));
            },

            /**
             * Configura contador AJAX
             */
            setupAjaxCounter: function() {
                if (!window.SIW.Reserva.ajaxCounter) {
                    window.SIW.Reserva.ajaxCounter = {
                        count: 0,
                        increment: function() {
                            this.count++;
                        },
                        decrement: function() {
                            this.count--;
                            if (this.count <= 0) {
                                SIWReserva.utils.loader('hide');
                            }
                        }
                    };

                    $(document).ajaxSend(function() {
                        window.SIW.Reserva.ajaxCounter.increment();
                    });

                    $(document).ajaxComplete(function() {
                        window.SIW.Reserva.ajaxCounter.decrement();
                    });

                    $(window).on('load', function() {
                        if (window.SIW.Reserva.ajaxCounter.count <= 0) {
                            SIWReserva.utils.loader('hide');
                        }
                    });
                }
            },

            // =================================================
            // CONFIGURACIÓN DE EVENTOS GLOBALES
            // =================================================

            setupGlobalEvents: function() {
                // Botón regresar a booking
                $(document).on('click', '#btn-back-to-booking', function(e) {
                    e.preventDefault();
                    const originalURL = SIWReserva.storage.get('originalBookingURL');
                    window.location.href = originalURL;
                });

            },

            // =================================================
            // CONFIGURACIÓN DE EVENTOS POR FASE
            // =================================================

            /**
             * Configura eventos específicos de booking
             */
            setupBookingEvents: function() {
                if (this._eventsRegistered) {
                    return;
                }
                this._eventsRegistered = true;

                // Selección de hora
                $(document).off('change', '.checkHora').on('change', '.checkHora', function(e) {
                    e.preventDefault();

                    const offerIndex = $(this).attr('name').replace('hora', '');
                    const $oferta = $(`#oferta-${offerIndex}`);
                    const selectedHour = $(`label[for="${$(this).attr('id')}"]`).text().trim();
                    const duracion = parseInt($oferta.data('duracion'), 10) || 90;
                    const [h, m] = selectedHour.split(':').map(Number);
                    const d = new Date(2000, 0, 1, h, m);
                    d.setMinutes(d.getMinutes() + duracion);

                    const horaFin =
                        String(d.getHours()).padStart(2, '0') + ':' +
                        String(d.getMinutes()).padStart(2, '0');

                    if (!config.validation.time.test(selectedHour)) {
                        SIWReserva.utils.handleError('Formato de hora inválido: ' + selectedHour, 'booking.checkHora');
                        alert('Error: Formato de hora inválido. Por favor, contacta con soporte.');
                        return;
                    }

                    const peopleCount = $('#peoples').val();
                    const modalidad = $(`#oferta-${offerIndex}`).attr('data-modalidad');
                    const modalidadid = $(`#oferta-${offerIndex}`).attr('data-modalidadid');
                    const fecha = $(`#oferta-${offerIndex}`).attr('data-fecha');
                    const preciosRaw = $(`#oferta-${offerIndex}`).attr('data-precios');
                    const precioid = $(`#oferta-${offerIndex}`).attr('data-precio-id');
                    const titulo = $(`#oferta-${offerIndex}`).attr('data-titulo');
                    const offerImage = $('#image-thumbnail').attr('src') || '';

                    const ciudad = $('#city').val();
                    const ciudadDescriptiva = $('#city option:selected').text();

                    const servicioId = $(`#oferta-${offerIndex}`).attr('data-servicio-id');
                    const vehiculoId = $(`#oferta-${offerIndex}`).attr('data-vehiculo-id');
                    const ofertaId = $(`#oferta-${offerIndex}`).attr('data-oferta-id');

                    // Validar y parsear precios
                    let precios = [];
                    try {
                        if (preciosRaw && preciosRaw.trim() !== '') {
                            precios = JSON.parse(preciosRaw);
                            if (!SIWReserva.priceManager.validatePrices(precios)) {
                                precios = [];
                            }
                        }
                    } catch (e) {
                        SIWReserva.utils.handleError('Error al parsear precios: ' + e.message, 'booking.checkHora');
                    }

                    // Crear precio por defecto si es necesario
                    if (precios.length === 0) {
                        const precioMostrado = $(`#oferta-${offerIndex} .precio-oferta`).text().trim();
                        let precioTotal = 0;

                        try {
                            const precioMatch = precioMostrado.match(/(\d+)[,\.](\d+)/);
                            if (precioMatch) {
                                precioTotal = parseFloat(`${precioMatch[1]}.${precioMatch[2]}`);
                            } else {
                                const precioEntero = precioMostrado.match(/(\d+)/);
                                if (precioEntero) {
                                    precioTotal = parseInt(precioEntero[1], 10);
                                }
                            }
                        } catch (e) {
                            SIWReserva.utils.handleError('Error al extraer precio de la UI: ' + e.message, 'booking.checkHora');
                        }

                        if (modalidad === 'PRIVATE') {
                            precios = [{ cantidad: 1, precio_unitario: precioTotal }];
                        } else {
                            precios = [{ cantidad: parseInt(peopleCount, 10), precio_unitario: precioTotal / parseInt(peopleCount, 10) }];
                        }
                    }

                    // Guardar datos

                    SIWReserva.storage.set('selectedHour', selectedHour);
                    SIWReserva.storage.set('peopleCount', peopleCount);
                    SIWReserva.storage.set('modalidad', modalidad);
                    SIWReserva.storage.set('modalidadid', modalidadid);
                    SIWReserva.storage.set('fecha', fecha);
                    SIWReserva.storage.set('precio', precios);
                    SIWReserva.storage.set('precioid', precioid);
                    SIWReserva.storage.set('titulo', titulo);
                    SIWReserva.storage.set('image', offerImage);
                    SIWReserva.storage.set('ciudad', ciudad);
                    SIWReserva.storage.set('ciudadDescriptiva', ciudadDescriptiva);
                    SIWReserva.storage.set('servicio_id', servicioId);
                    SIWReserva.storage.set('vehiculo_id', vehiculoId);
                    SIWReserva.storage.set('oferta_id', ofertaId);
                    SIWReserva.storage.set('duracion', duracion);
                    SIWReserva.storage.set('hora_fin', horaFin);

                    // Habilitar botón de reserva
                    $(`#bookNow-${offerIndex}`).prop('disabled', false);

                    // Deshabilitar otros botones
                    $('.checkHora').each(function() {
                        const currentOfferIndex = $(this).attr('name').replace('hora', '');
                        if (currentOfferIndex !== offerIndex) {
                            $(this).prop('checked', false);
                            $(`#bookNow-${currentOfferIndex}`).prop('disabled', true);
                        }
                    });
                });

                // Cambio de fecha
                $(document).on('change', '.fecha', function() {
                    if (SIWReserva.hasSearched) {
                        SIWReserva.fases.searchOffers();
                    }
                });

                // Incremento/decremento de personas
                $(document).off('click', '.booking-plus').on('click', '.booking-plus', function() {
                    const quantityInput = $('#peoples');
                    const max = parseInt(quantityInput.attr('max'), 10);
                    let currentValue = parseInt(quantityInput.val(), 10);

                    if (currentValue < max) {
                        currentValue += 1;
                        quantityInput.val(currentValue);
                    }
                });

                $(document).off('click', '.booking-minus').on('click', '.booking-minus', function() {
                    const quantityInput = $('#peoples');
                    const min = parseInt(quantityInput.attr('min'), 10);
                    let currentValue = parseInt(quantityInput.val(), 10);

                    if (currentValue > min) {
                        currentValue -= 1;
                        quantityInput.val(currentValue);
                    }
                });

                $(document).on('change', '#peoples', function() {
                    if (SIWReserva.hasSearched) {
                        SIWReserva.fases.searchOffers();
                    }
                });

                // Búsqueda de disponibilidad
                $(document).off('click', '.btnGetDisponibility').on('click', '.btnGetDisponibility', function() {
                    const reservationStartTime = Math.floor(Date.now() / 1000);
                    SIWReserva.storage.set('reservationStartTime', reservationStartTime);
                    SIWReserva.storage.set('originalBookingURL', window.location.href);
                    SIWReserva.fases.searchOffers();
                    SIWReserva.utils.scrollTo('#offersContainer', 100);
                });

                // Cambio de ciudad
                $('#city').off('change').on('change', function() {
                    SIWReserva.fases.loadInitialData($(this).val());
                });

                // Evento para botones de reserva
                $(document).off('click', '.book-now').on('click', '.book-now', async function(e) {
                    e.preventDefault();

                    const offerIndex = $(this).attr('id').split('-')[1];

                    const selectedHourInput = $(`input[name="hora${offerIndex}"]:checked`);
                    const selectedHour = selectedHourInput.length > 0 ? selectedHourInput.attr('id') : null;

                    const passport = $(this).data('passport');

                    if (!selectedHour) {
                        alert('Por favor, selecciona una hora antes de continuar.');
                        return false;
                    }

                    // Obtener datos de la oferta desde el contenedor
                    const $offerContainer = $(`#oferta-${offerIndex}`);
                    const modalidad = $offerContainer.data('modalidad');
                    const titulo = $offerContainer.data('titulo');
                    const ciudad = $offerContainer.data('ciudad');
                    const fecha = $offerContainer.data('fecha');
                    const servicioId = $offerContainer.data('servicio-id');
                    const vehiculoId = $offerContainer.data('vehiculo-id');
                    const ofertaId = $offerContainer.data('oferta-id');

                    // Obtener duración del texto
                    const duracion = $offerContainer.data('duracion');

                    // Obtener descripción
                    const descripcion = $offerContainer.find('p').first().text();

                    // Obtener precios del data-attribute
                    const preciosRaw = $offerContainer.attr('data-precios');
                    let precios = [];
                    try {
                        precios = JSON.parse(preciosRaw || '[]');
                    } catch (e) {
                        SIWReserva.utils.log('Error al parsear precios: ' + e, 'error', 'fases.setupBookingEvents');
                    }
                    if (!Array.isArray(precios) || precios.length === 0) {
                        alert('Error al procesar la oferta. Por favor, selecciona otra oferta o recarga la página.');
                        return false;
                    }

                    // Obtener hora seleccionada (texto del label)
                    const selectedHourText = selectedHourInput.length > 0 ? $(`label[for="${selectedHourInput.attr('id')}"]`).text().trim() : '';

                    // Guardar todos los datos en localStorage
                    SIWReserva.storage.set('selectedHour', selectedHourText);
                    SIWReserva.storage.set('modalidad', modalidad);
                    SIWReserva.storage.set('duracion', duracion);
                    SIWReserva.storage.set('descripcion', descripcion);
                    SIWReserva.storage.set('precio', precios);
                    SIWReserva.storage.set('passport', passport);
                    SIWReserva.storage.set('peopleCount', $('#peoples').val() || 1);
                    SIWReserva.storage.set('fecha', fecha);
                    SIWReserva.storage.set('ciudad', ciudad);
                    SIWReserva.storage.set('ciudadDescriptiva', $('#dynamic-city').text() || ciudad);
                    SIWReserva.storage.set('titulo', titulo);
                    SIWReserva.storage.set('servicio_id', servicioId);
                    SIWReserva.storage.set('vehiculo_id', vehiculoId);
                    SIWReserva.storage.set('oferta_id', ofertaId);
                    SIWReserva.storage.set('reservationStartTime', Math.floor(Date.now() / 1000));

                    // [monitor] Transición Fase 1 → Fase 2: usuario seleccionó oferta y va a extras
                    SIWReserva._monitorLog('fase2_inicio', SIWReserva.getSessionId(), 'Usuario en fase extras', 'info', {
                        ciudad:      ciudad ?? null,
                        servicio_id: servicioId ?? null,
                        fecha:       fecha ?? null,
                        hora:        selectedHourText ?? null,
                        personas:    SIWReserva.storage.get('peopleCount') ?? null,
                        precio:      precios ?? null,
                    });

                    // Mostrar loading en el botón
                    const $button = $(this);
                    SIWReserva.utils.toggleLoading($button[0], true);
                    try {
                        await SIWReserva.storage.syncToStorage();
                        setTimeout(function() {
                            window.location.href = API_ROUTES.renderExtras;
                        }, 1000);
                    } catch (error) {
                        console.error('Error syncing to storage:', error);
                        alert('Error al sincronizar datos. Por favor, inténtalo de nuevo. Err 202');
                        return false;
                    }

                    return false;
                });

            },

            /**
             * Configura eventos específicos de extras
             */
            setupExtrasEvents: function() {
                // Incremento de extras
                $(document).off('click', '.extras-plus').on('click', '.extras-plus', function() {
                    const card = $(this).closest('.card');
                    const quantityInput = card.find('.product-quantity');
                    const max = parseInt(quantityInput.attr('max'), 10);
                    let currentValue = parseInt(quantityInput.val(), 10);

                    if (currentValue < max) {
                        currentValue += 1;
                        quantityInput.val(currentValue);

                        const extraId = card.data('extra-id');
                        const extraName = card.find('.card-title').text().trim();
                        const extraPrice = card.find('.price-tag').text().trim();

                        SIWReserva.extrasManager.updateExtra(extraId, extraName, extraPrice, currentValue);
                    }
                });

                // Decremento de extras
                $(document).off('click', '.extras-minus').on('click', '.extras-minus', function() {
                    const card = $(this).closest('.card');
                    const quantityInput = card.find('.product-quantity');
                    const min = parseInt(quantityInput.attr('min'), 10);
                    let currentValue = parseInt(quantityInput.val(), 10);

                    if (currentValue > min) {
                        currentValue -= 1;
                        quantityInput.val(currentValue);

                        const extraId = card.data('extra-id');
                        const extraName = card.find('.card-title').text().trim();
                        const extraPrice = card.find('.price-tag').text().trim();

                        SIWReserva.extrasManager.updateExtra(extraId, extraName, extraPrice, currentValue);
                    }
                });

                // Continuar a pago
                $(document).off('click', '.book-now-topay').on('click', '.book-now-topay', async function() {
                    try {
                        const selectedExtras = SIWReserva.storage.get('selectedExtras', []);

                        if (selectedExtras.length === 0) {
                            SIWReserva.storage.set('selectedExtras', []);
                        }

                        // [monitor] Transición Fase 2 → Fase 3: usuario va al formulario de datos
                        SIWReserva._monitorLog('datos_cliente', SIWReserva.getSessionId(), 'Usuario en fase formulario', 'info', {
                            extras: selectedExtras ?? null,
                        });

                        await SIWReserva.storage.syncToStorage();
                        setTimeout(function() {
                            window.location.href = API_ROUTES.renderPayment;
                        }, 1000);
                    } catch (error) {
                        console.error('Error syncing to storage:', error);
                        alert('Error al sincronizar datos. Por favor, inténtalo de nuevo. Err 201');
                        return false;
                    }
                });

            },

            /**
             * Configura eventos específicos de payment
             */
            setupPaymentEvents: function() {
                $(document).off('click', '#bookNow-pay').on('click', '#bookNow-pay', function(e) {
                    e.preventDefault();
                    SIWReserva.paymentProcessor.process();
                    return false;
                });

                $(document).off('click', '.apply-promo').on('click', '.apply-promo', function(e) {
                    e.preventDefault();

                    const button = $(this);
                    const promoInput = $('#promo-code');

                    if (button.text() === 'Aplicar') {
                        const promoCode = promoInput.val().trim();

                        if (!promoCode) {
                            $('.promo-feedback.text-danger').text('Por favor, introduce un código promocional.').removeClass('d-none');
                            $('.promo-feedback.text-success').addClass('d-none');
                            return;
                        }

                        button.html('<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>');
                        button.prop('disabled', true);

                        SIWReserva.promoManager.apply(promoCode, function(success, message) {
                            button.html('Aplicar');
                            button.prop('disabled', false);

                            if (success) {
                                $('#promo-discount').text(message + ' EUR');
                                $('.promo-feedback.text-success').removeClass('d-none');
                                $('.promo-feedback.text-danger').addClass('d-none');
                                promoInput.prop('disabled', true);
                                button.text('Limpiar').removeClass('btn-outline-secondary').addClass('btn-danger');
                            } else {
                                $('.promo-feedback.text-danger').text(message).removeClass('d-none');
                                $('.promo-feedback.text-success').addClass('d-none');
                            }
                        });

                    } else {
                        // Limpiar cupón
                        promoInput.prop('disabled', false).val('');
                        button.text('Aplicar').removeClass('btn-danger').addClass('btn-outline-secondary');
                        $('.promo-feedback.text-success, .promo-feedback.text-danger').addClass('d-none');

                        SIWReserva.promoManager.clear();
                    }

                    return false;
                });
            },

            /**
             * Busca ofertas disponibles
             */
            searchOffers: function() {
                const peoples = $('#peoples').val();
                const date = $('.fecha').val();
                const city = $('#city').val();

                if (!peoples || !date || !city) {
                    alert('Por favor, completa todos los campos.');
                    return;
                }

                SIWReserva.utils.toggleLoading('#btnGetDisponibility', true, 'Buscando...');

                const data = { peoples, date, city };

                const vehicleType = window.SIW_CONFIG?.VEHICLE_TYPE;
                if (vehicleType !== null && vehicleType !== undefined) {
                    const tipos_servicio = ['Beer Bike', 'Pedal Boat', 'Sailing Boat', 'Dinner Boat'];
                    data.service_type = tipos_servicio[vehicleType];
                }

                $.ajax({
                    url: API_ROUTES.getBookingOffer,
                    method: 'POST',
                    data: data,
                    beforeSend: function() {
                        SIWReserva.utils.loader('loading');
                    },
                    success: function(response) {
                        window.siw_consola('ofertas', 'response')

                        SIWReserva.utils.toggleLoading('#btnGetDisponibility', false, 'Ver Disponibilidad');

                        if (Array.isArray(response.ofertas) && response.ofertas.length > 0) {

                            const offers = response.ofertas;
                            const container = $('#offersContainer');
                            container.empty();

                            container.html(response.html);
                            window.siw_consola('Ofertas', offers);
                            $('.offer-card').addClass('animate__animated animate__fadeIn');
                            SIWReserva.hasSearched = true;
                        } else {
                            alert('No se encontraron ofertas disponibles.');
                        }
                    },
                    complete: function() {
                        SIWReserva.utils.loader('hide');
                    },
                    error: function(xhr) {
                        SIWReserva.utils.toggleLoading('#btnGetDisponibility', false, 'Ver Disponibilidad');
                        SIWReserva.utils.handleError(xhr.responseText || xhr.statusText, 'fases.searchOffers');
                        alert('Error al buscar disponibilidad.');
                    }
                });
            },

            /**
             * NUEVO: Método específico para booking.blade.php
             */
            execBooking: function(config = {}) {
                SIWReserva.utils.log('Ejecutando método específico para booking.blade.php', 'info', 'fases.execBooking');

                // Configurar flatpickr si se proporcionan fechas deshabilitadas
                if (config.fechasDeshabilitadas && Array.isArray(config.fechasDeshabilitadas)) {
                    SIWReserva.utils.configurarFlatpickr('#date', config.fechasDeshabilitadas);
                }

                // Configurar valor inicial de personas
                $('#peoples').val(1);

                // Scroll inicial
                SIWReserva.utils.scrollTo('body', 0, 1);

                // Cargar ciudad desde parámetro URL si se proporciona
                if (config.cityParam) {
                    this.loadCities(config.cityParam);
                }

                // Cargar datos iniciales
                setTimeout(() => {
                    const cityValue = $('#city').val() || 'bcn';
                }, 500);

                // Configurar evento para botón del sidebar
                $('#btnVerDisponibilidadAnchor').off('click').on('click', function() {
                    SIWReserva.utils.scrollTo('#form-section', 100);
                });

                // Inicializar fase booking
                this.booking();
            },

            /**
             * NUEVO: Método específico para extras.blade.php
             */
            execExtras: function(config = {}) {

                SIWReserva.utils.scrollTo('body', 0, 1);

                // Verificar datos de reserva
                const fecha = SIWReserva.storage.get('fecha');
                const selectedHour = SIWReserva.storage.get('selectedHour');

                if (!fecha || !selectedHour) {
                    alert('Error en parametros. Intente de nuevo o contactenos y notifique el siguiente código: E01002.');
                    SIW.Reserva.utils.log('Errores de validación de fecha', 'error', 'execExtras');
                    SIW.Reserva.utils.log('Argumentos:', 'error', 'execExtras');
                    SIW.Reserva.utils.log('    - fecha        ->> ' + fecha, 'error', 'execExtras');
                    SIW.Reserva.utils.log('    - selectedHour ->> ' + selectedHour, 'error', 'execExtras');
                    SIWReserva.utils.redirect(window.bbb.config['URL Fallback Redirection'], true);
                    return;
                }

                // Inicializar fase extras
                this.extras();
            },

            /**
             * NUEVO: Método específico para payment.blade.php
             */
            execPayment: function(config = {}) {

                SIWReserva.utils.scrollTo('body', 0, 1);

                SIWReserva.utils.log('Ejecutando método específico para payment.blade.php', 'info', 'fases.execPayment');

                // Verificar datos críticos
                const validation = SIWReserva.formValidator.validateCriticalData();
                if (!validation) {
                    alert('Error en parametros. Intente de nuevo o contactenos y notifique el siguiente código: E01001.');
                    SIWReserva.utils.redirect(window.bbb.config['URL Fallback Redirection'], true);
                    return;
                }

                // Configurar contador de tiempo si está habilitado
                if (config.enableTimer !== false) {
                    this.setupPaymentTimer();
                }

                // Inicializar fase payment
                this.payment();

            },

            /**
             * NUEVO: Configurar contador de tiempo para payment
             */
            setupPaymentTimer: function() {
                const reservationStartTime = SIWReserva.storage.get('reservationStartTime');
                if (!reservationStartTime) return;

                const tiempo = parseInt(window.bbb.config['Tiempo para reservar en minutos']) || 30;
                const tiempoLimite = tiempo * 60;
                let expired = false; // ← flag

                function actualizarContador() {
                    const tiempoActual = Math.floor(Date.now() / 1000);
                    const tiempoTranscurrido = tiempoActual - reservationStartTime;
                    const tiempoRestante = Math.max(0, tiempoLimite - tiempoTranscurrido);

                    if (tiempoRestante > 0) {
                        const minutos = Math.floor(tiempoRestante / 60);
                        const segundos = tiempoRestante % 60;
                        $('#countdown-timer').text(`${minutos}:${segundos.toString().padStart(2, '0')} minutos`);
                        if (tiempoRestante < 300) {
                            $('#countdown-timer').parent().removeClass('text-dark').addClass('text-danger');
                        }
                    } else if (!expired) { // ← solo una vez
                        expired = true;
                        clearInterval(timer); // ← para el intervalo
                        $('#countdown-timer').text('¡Tiempo agotado!');
                        $('#countdown-timer').parent().removeClass('text-dark').addClass('text-danger');
                        setTimeout(() => {
                            alert('El tiempo de reserva ha expirado. Serás redirigido para hacer una nueva reserva.');
                            SIWReserva.utils.redirect(window.bbb.config['URL Fallback Redirection'], true);
                        }, 2000);
                    }
                }

                actualizarContador();
                const timer = setInterval(actualizarContador, 1000); // ← guardar referencia
            }
        },

        /**
         * NUEVO: Método principal para ejecutar fases específicas desde los blades
         */
        exec: function(fase, config = {}) {

            if (!this._initialized) {
                this.init();
            }

            // Merge configuración global si existe
            if (window.SIW_CONFIG) {
                Object.assign(SIWReserva.getConfig(), window.SIW_CONFIG);
            }

            // Ejecutar método específico según la fase
            switch(fase) {
                case 'booking':
                    SIWReserva.fases.execBooking(config);
                    break;
                case 'extras':
                    SIWReserva.fases.execExtras(config);
                    break;
                case 'payment':
                    SIWReserva.fases.execPayment(config);
                    break;
                default:
                    return false;
            }

            return true;
        },

        // =================================================
        // MÉTODOS PÚBLICOS PRINCIPALES
        // =================================================

        /**
         * Inicializa el módulo
         */
        init: function(fase = null) {

            if (this._initialized) {
                return;
            }

            this._initialized = true;

            // Cargar configuración global
            SIWReserva.utils.obtenerConfigGlobal();

            // Verificar dependencias
            SIWReserva.utils.verificarDependencias();

            // Configurar variables globales
            SIWReserva.hasSearched = false;

            SIWReserva.fases.setupGlobalEvents();

            if (fase) {
                // Inicialización manual por fase
                if (typeof SIWReserva.fases[fase] === 'function') {
                    SIWReserva.fases[fase]();
                } else {
                    SIWReserva.utils.handleError('Fase no válida: ' + fase, 'main.init');
                }
            } else {
                SIWReserva.utils.log('Autodetectando fase ... ', 'info', 'Init');
            }

            // Configurar resize observer para iframe
            SIWReserva.setupResizeObserver();
        },

        /**
         * Obtiene configuración actual
         */
        getConfig: function() {
            return config;
        },

        /**
         * Actualiza configuración
         */
        setConfig: function(newConfig) {
            Object.assign(config, newConfig);
        },

        /**
         * Limpia datos de sesión
         */
        clearSessionData: function() {
        },

        /**
         * Configura observer para resize de iframe
         */
        setupResizeObserver: function() {
            function enviarAltura() {
                const altura = document.body.scrollHeight;
                window.parent.postMessage({
                    tipo: 'resize',
                    altura: altura
                }, '*');
            }

            const observer = new ResizeObserver(() => {
                enviarAltura();
            });
            observer.observe(document.body);
            window.addEventListener('load', enviarAltura);
        }

    };

    // =====================================================
    // EXPOSICIÓN DEL MÓDULO
    // =====================================================

    // Crear namespace SIW si no existe.
    window.SIW = window.SIW || {};

    // Exponer el módulo
    window.SIW.Reserva = SIWReserva;

    // =====================================================
    // COMPATIBILIDAD CON CÓDIGO EXISTENTE
    // =====================================================

    // Mantener aliases temporales para compatibilidad
    window.bbbk = {
        utils: SIWReserva.utils,
        storage: SIWReserva.storage,
        priceManager: SIWReserva.priceManager,
        summaryManager: SIWReserva.summaryManager,
        extrasManager: SIWReserva.extrasManager,
        promoManager: SIWReserva.promoManager,
        formValidator: SIWReserva.formValidator,
        paymentProcessor: SIWReserva.paymentProcessor,

        // Funciones de inicialización por compatibilidad
        bookingInit: function() { SIWReserva.fases.booking(); },
        extrasInit: function() { SIWReserva.fases.extras(); },
        paymentInit: function() { SIWReserva.fases.payment(); },
        autoInit: function() { SIWReserva.fases.autoDetect(); },
        clearSessionData: function() { SIWReserva.clearSessionData(); },

        // Variables de compatibilidad
        vars: { hasSearched: false },

        // Funciones de utilidad por compatibilidad
        getUrlParameter: SIWReserva.utils.getUrlParameter,
        getParameterByName: SIWReserva.utils.getUrlParameter
    };

    // =====================================================
    // INICIALIZACIÓN AUTOMÁTICA
    // =====================================================

    $(document).ready(function() {
        // Inicializar automáticamente
        // if (window.SIW && window.SIW.Reserva) {
        //     window.SIW.Reserva.init();
        // }
    });

    // =====================================================
    // RETORNO DEL MÓDULO
    // =====================================================

    return SIWReserva;

})(jQuery);

window.onCityFormTurnstileSuccess = function(token) {
    document.getElementById('city-contact-submit').disabled = false;
    document.getElementById('cf-turnstile-city-token').value = token;
};
